import { OrderRequestItemStatus } from "../core/global";
import { ApiResponse, err, getAxios, postAxios, processError, res } from "./axios";

interface GetOrderDetailsProps {
  order_id: number | string | null
}

export const getOrderDetails = async ({
  order_id,
}: GetOrderDetailsProps ):Promise<ApiResponse> => {
  try {
    const result = await getAxios(`/api/v1/orders/get-order-details/${order_id}/`, false)
    const response = result?.data || null
    return res(response)

  } catch (e) {
    const {status, message} = processError(e, `Error retrieving **#${order_id}** order details.`)
    return err(message, status)
  }
}


interface GetOrderDetailsContentProps {
  order_id: number | string | null
}

export const getOrderDetailsContent = async ({
  order_id,
}: GetOrderDetailsContentProps ):Promise<ApiResponse> => {
  try {
    const result = await getAxios(`/api/v1/orders/get-order-content/${order_id}/`, false)
    const response = result?.data || null
    return res(response)

  } catch (e) {
    const {status, message} = processError(e, `Error retrieving **#${order_id}** order details content.`)
    return err(message, status)
  }
}


interface GetCompanyOrdersRequestsProps {
  company_id: number | string | null
}

export const getCompanyOrdersRequests = async ({
  company_id,
}: GetCompanyOrdersRequestsProps ):Promise<ApiResponse> => {
  try {
    const result = await getAxios(`/api/v1/orders/get-orders-requests/${company_id}/`, false)
    const response = result?.data || null
    return res(response)

  } catch (e) {
    const {status, message} = processError(e, `Error retrieving company order requests.`)
    return err(message, status)
  }
}


export const getUserCompanyOrdersRequests = async ():Promise<ApiResponse> => {
  try {
    const result = await getAxios(`/api/v1/orders/get-all-orders-requests`, false)
    const response = result?.data || null
    return res(response)

  } catch (e) {
    const {status, message} = processError(e, `Error retrieving user's company order requests.`)
    return err(message, status)
  }
}

export const getCurrentUserCompanyPurchaseRequests = async ():Promise<ApiResponse> => {
  try {
    const result = await getAxios(`/api/v1/orders/get-user-orders-requests`, false)
    const response = result?.data || null
    return res(response)

  } catch (e) {
    const {status, message} = processError(e, `Error retrieving order requests by uid.`)
    return err(message, status)
  }
}


interface UpdateRequestItemProps {
  id: number | string
  company_id: number | string
  status: OrderRequestItemStatus
}

export const updateRequestItem = async ({
  id,
  company_id,
  status,
}: UpdateRequestItemProps):Promise<ApiResponse> => {
  try {
    const result = await postAxios(`/api/v1/orders/update-orders-request`, {
      id,
      status,
      company_id,
    }, false)
    const response = result?.data || null
    return res(response)
  } catch (e) {
    const {status, message} = processError(e, "Error updating order request.")
    return err(message, status)
  }
}


interface RejectRequestItemProps {
  order_item_id: number | string
}

export const rejectRequestItem = async ({
  order_item_id
}: RejectRequestItemProps):Promise<ApiResponse> => {
  try {
    const result = await postAxios(`/api/v1/orders/reject-order-request-item/`, {
      order_item_id,
    }, false)
    const response = result?.data || null
    return res(response)
  } catch (e) {
    const {status, message} = processError(e, "Error rejecting order request.")
    return err(message, status)
  }
}


interface RevokeRequestItemProps {
  request_item_id: number | string
}

export const revokeRequestItem = async ({
  request_item_id
}: RevokeRequestItemProps):Promise<ApiResponse> => {
  try {
    const result = await postAxios(`/api/v1/orders/revoke-order-request-item/`, {
      request_item_id,
    }, false)
    const response = result?.data || null
    return res(response)
  } catch (e) {
    const {status, message} = processError(e, "Error revoking order request.")
    return err(message, status)
  }
}

interface GetOrderSharesProps {
  order_item_id: number | string | null
}

export const getOrderShares = async ({
  order_item_id,
}: GetOrderSharesProps ):Promise<ApiResponse> => {
  try {
    
    const result = await getAxios(`/api/v1/orders/get-order-shares/${order_item_id}/`, false)
    const response = result?.data || null
    return res(response)

  } catch (e) {
    const {status, message} = processError(e, `Error retrieving **#${order_item_id}** order item shares.`)
    return err(message, status)
  }
}


interface GetProjectSharesProps {
  project_id: number | string | null
}

export const getProjectShares = async ({
  project_id,
}: GetProjectSharesProps ):Promise<ApiResponse> => {
  try {
    
    const result = await getAxios(`/api/v1/orders/get-project-shares/${project_id}/`, false)
    const response = result?.data || null
    return res(response)

  } catch (e) {
    const {status, message} = processError(e, `Error retrieving **#${project_id}** project shares.`)
    return err(message, status)
  }
}


interface RemoveProjectShareProps {
  id: number | string | null
}

export const removeProjectShare = async ({
  id,
}: RemoveProjectShareProps ):Promise<ApiResponse> => {
  try {
    const result = await postAxios(`/api/v1/orders/delete-project-share-by-id`, {
      id,
    }, false)
    const response = result?.data || null
    return res(response)

  } catch (e) {
    const {status, message} = processError(e, `Error removing user from project sharing.`)
    return err(message, status)
  }
}


interface AddProjectShareProps {
  project_id: number | string | null
  email?: string | null
}

export const addProjectShareByEmail = async ({
  project_id,
  email,
}: AddProjectShareProps ):Promise<ApiResponse> => {
  try {
    const result = await postAxios(`/api/v1/orders/add-project-share-by-email`, {
      project_id,
      email,
    }, false)
    const response = result?.data || null
    return res(response)

  } catch (e) {
    const {status, message} = processError(e, `Error sharing project folder.`)
    return err(message, status)
  }
}


interface RemoveOrderShareProps {
  id: number | string | null
}

export const removeOrderShare = async ({
  id,
}: RemoveOrderShareProps ):Promise<ApiResponse> => {
  try {
    const result = await postAxios(`/api/v1/orders/delete-order-share-by-id`, {
      id,
    }, false)
    const response = result?.data || null
    return res(response)

  } catch (e) {
    const {status, message} = processError(e, `Error removing user from sharing.`)
    return err(message, status)
  }
}



interface AddOrderShareProps {
  order_item_id: number | string | null
  email?: string | null
}

export const addOrderShareByEmail = async ({
  order_item_id,
  email,
}: AddOrderShareProps ):Promise<ApiResponse> => {
  try {
    const result = await postAxios(`/api/v1/orders/add-order-share-by-email`, {
      order_item_id,
      email,
    }, false)
    const response = result?.data || null
    return res(response)

  } catch (e) {
    const {status, message} = processError(e, `Error sharing data.`)
    return err(message, status)
  }
}